module.exports = [
	"aa_item_page_1",
	"aa_item_page_10",
	"aa_item_page_11",
	"aa_item_page_12",
	"aa_item_page_13",
	"aa_item_page_14",
	"aa_item_page_15",
	"aa_item_page_2",
	"aa_item_page_3",
	"aa_item_page_4",
	"aa_item_page_5",
	"aa_item_page_6",
	"aa_item_page_7",
	"aa_item_page_8",
	"aa_item_page_9",
	"aa_marketplace",
	"aa_marketplace_10",
	"aa_marketplace_11",
	"aa_marketplace_12",
	"aa_marketplace_13",
	"aa_marketplace_14",
	"aa_marketplace_15",
	"aa_marketplace_2",
	"aa_marketplace_3",
	"aa_marketplace_4",
	"aa_marketplace_5",
	"aa_marketplace_6",
	"aa_marketplace_7",
	"aa_marketplace_8",
	"aa_marketplace_9",
	"ada_chat_bot",
	"affirm_split_pay",
	"aftership_shipment_tracking",
	"android_aa",
	"android_aa_10_q3_21",
	"android_aa_11_q3_21",
	"android_aa_12_q3_21",
	"android_aa_13_q3_21",
	"android_aa_14_q3_21",
	"android_aa_15_q3_21",
	"android_aa_1_q3_21",
	"android_aa_2_q3_21",
	"android_aa_3_q3_21",
	"android_aa_4_q3_21",
	"android_aa_5_q3_21",
	"android_aa_6_q3_21",
	"android_aa_7_q3_21",
	"android_aa_8_q3_21",
	"android_aa_9_q3_21",
	"android_ada_chatbot",
	"android_autosuggest",
	"android_bottom_navigation",
	"android_csp_filters",
	"android_csp_specs",
	"android_csp_within_search_results",
	"android_filters_ux",
	"android_homepage_affinities",
	"android_homepage_curation",
	"android_load_more",
	"android_my_updates",
	"android_my_updates_v2",
	"android_recommendation_row",
	"android_retail_standards",
	"android_rvp_logic",
	"android_search_filters_seller_location",
	"android_webview_login",
	"app_install_callout",
	"app_install_callout_qr_code",
	"app_store_developer",
	"blocked_from_flagging_listings",
	"boost_marketplace_seller_location",
	"bump_from_core",
	"bump_recommendation_featured_winner_fix",
	"canadian_gst_input",
	"carrier_calculated_buyer",
	"carrier_calculated_seller",
	"checkout_standards_update",
	"cms_exp_free_shipping",
	"create_custom_tax_policy",
	"criteo_tracking",
	"csp_card",
	"csp_search_ads",
	"csv_bump_recs",
	"dashboard_price_drop_report",
	"data_driven_well_priced_listings",
	"disable_csv_imports",
	"disable_gmc_workers",
	"disable_international_support_phones",
	"disable_push_webhook_worker",
	"disable_saved_search_emails",
	"disable_search_indexer_csp_updates",
	"dummy",
	"email_offers",
	"ended_listing_page_ad",
	"etsy_adyen_config",
	"execute_3ds",
	"facebook_api_v6",
	"feed_postgres_reads",
	"fsox_mv_threshold",
	"gearnuts_import",
	"generic_csp_show_new",
	"google_auth",
	"hidden_seller_sales",
	"homepage_affinity_ads",
	"internal_gift_card_auto_approval",
	"international_address_form_checkout",
	"international_address_form_core",
	"ios_aa",
	"ios_aa_10_q3_21",
	"ios_aa_11_q3_21",
	"ios_aa_12_q3_21",
	"ios_aa_13_q3_21",
	"ios_aa_14_q3_21",
	"ios_aa_15_q3_21",
	"ios_aa_1_q3_21",
	"ios_aa_2_q3_21",
	"ios_aa_3_q3_21",
	"ios_aa_4_q3_21",
	"ios_aa_5_q3_21",
	"ios_aa_6_q3_21",
	"ios_aa_7_q3_21",
	"ios_aa_8_q3_21",
	"ios_aa_9_q3_21",
	"ios_ada_chatbot",
	"ios_affirm_callout",
	"ios_autosuggest",
	"ios_csp_filters",
	"ios_csp_specs",
	"ios_csp_within_results",
	"ios_etsy_adyen_config",
	"ios_filters_ux",
	"ios_home_search",
	"ios_homepage_affinities",
	"ios_homepage_recency",
	"ios_my_updates",
	"ios_news_refactor",
	"ios_recommendation_row",
	"ios_retail_standards_v2",
	"ios_rvp_logic",
	"ios_search_load_more",
	"ios_search_refactor",
	"ios_webview_login",
	"item2_buyer_trust",
	"item2_pickup_nearby",
	"item2_retail_standards",
	"item_lazy_toggled_content",
	"listing_card_location",
	"listing_description_flagging",
	"listing_lightbox_image",
	"listing_sidebar_csp_pg_estimates",
	"listings_query_rewrite",
	"logged_in_homepage_personalized_bump_row",
	"login_verification",
	"looker_dash",
	"make_auctions",
	"marketplace_grid_ads",
	"marketplace_multi_bump_row",
	"message_link_redirects",
	"mobile_native_redirects",
	"mobile_onboarding_redirect",
	"mv_dummy",
	"next_adyen_checkout_version",
	"offer_quantity",
	"ops_sift_always_pass_verification",
	"packlink",
	"premium_ad_mosaic",
	"product_family_quicklinks",
	"product_family_redirects",
	"product_preorders",
	"proximity_features",
	"proximity_filter_marketplace",
	"published_listing_shipping_prompt",
	"quick_shipper_speed_nudge",
	"redesigned_listing_card",
	"router_scroll_to_top",
	"routing_number_validation_exception",
	"rre_throttle",
	"rsl_preferred_ui",
	"rule_of_100_price_display",
	"secondary_homepage_banner",
	"seller_affirm_promotion",
	"seller_auto_offer_ui",
	"separate_paypal_liable_account",
	"set_google_merchant_center_shipping_settings",
	"shop_bank_changes_require_unlocked_status",
	"shop_follower_tab",
	"show_plaid_link",
	"show_product_family_page_links",
	"show_referral_survey",
	"show_reverb_sales_nag_banners",
	"ssr_homepage_feed_row",
	"store_shipment_tracking_notifications",
	"sunset_sites",
	"trait_facets",
	"uk_default_sitebanner_image",
	"unboost_make_model",
	"upc_required",
	"v2_automatching",
	"v2_site_search_recently_viewed",
	"validate_android_attestation_token",
	"vat_verification_failure_email",
	"view_wip_locales",
	"warmup",
	"web_recommendations",
	"withhold_payouts_pending_seller_verification"
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/dist/experiments.json
// module id = VXgp
// module chunks = 24